var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner-bill-page"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('el-tab-pane',{attrs:{"label":"维保记录","name":"list"}},[_c('service-list')],1),_c('el-tab-pane',{attrs:{"label":"统计分析","name":"stat","lazy":""}},[_c('bill-stat')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }